// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__OocOr","inputWrap":"Table_inputWrap__2XO7M","col":"Table_col__3O4Bq","bmiTooltip":"Table_bmiTooltip__2Lc93"};